import { useEffect, useState } from "react";


import powiatyGminy from './powiaty_gminy.json';

type PowiatyGminy = {
    [powiat: string]: {
        [gmina: string]: string;
    };
};
const powiatyGminyTyped: PowiatyGminy = powiatyGminy;

const bankMapping: { [key: string]: string } = {
    "1010": "Narodowy Bank Polski",
    "1020": "PKO Bank Polski",
    "1030": "Bank Handlowy (Citi Handlowy)",
    "1050": "ING Bank Śląski",
    "1060": "Bank BPH",
    "1090": "Santander Bank Polska",
    "1130": "Bank Gospodarstwa Krajowego (BGK)",
    "1140": "mBank",
    "1160": "Bank Millennium",
    "1240": "Bank Pekao SA",
    "1280": "HSBC Bank Polska",
    "1320": "Bank Pocztowy",
    "1540": "BOŚ Bank",
    "1580": "Mercedes-Benz Bank Polska",
    "1610": "SGB-Bank",
    "1680": "Plus Bank",
    "1840": "Société Générale",
    "1870": "Nest Bank",
    "1930": "Bank Polskiej Spółdzielczości",
    "1940": "Credit Agricole Bank Polska",
    "1950": "Idea Bank",
    "2030": "BNP Paribas",
    "2120": "Santander Consumer Bank",
    "2130": "Volkswagen Bank",
    "2160": "Toyota Bank",
    "2190": "DNB Bank Polska",
    "2490": "Alior Bank",
    "2710": "FCE Bank Polska",
    "2720": "Inbank",
    "2770": "Volkswagen Bank",
    "2800": "HSBC",
    "2850": "BFF Bank",
    "2870": "Bank Nowy",
    "2910": "Aion Bank",
    "2930": "VeloBank",
    "1011": "NBP Oddział Okręgowy",
    "1031": "CitiBank Europe plc",
    "1040": "Deutsche Bank Polska",
    "1070": "Euro Bank (obecnie Santander)",
    "1100": "Bank Współpracy Europejskiej (dawny)",
    "1120": "Bank Crédit Lyonnais (dawny)",
    "1150": "Bank Zachodni WBK (obecnie Santander)",
    "1170": "Raiffeisen Bank Polska (obecnie BNP Paribas)",
    "1200": "Nordea Bank Polska (obecnie PKO BP)",
    "1260": "State Street Bank International",
    "1270": "Danske Bank A/S",
    "1290": "Noble Bank (część Getin Banku)",
    "1300": "FM Bank (obecnie Nest Bank)",
    "1330": "NeoBank (Wielkopolski Bank Spółdzielczy)",
    "1350": "Idea Bank (część Pekao SA)",
    "1370": "Bank Spółdzielczy w Brodnicy",
    "1380": "Bank Spółdzielczy Rzemiosła w Krakowie",
    "1400": "Revolut Bank UAB",
    "1410": "Wise Payments Limited (TransferWise)",
    "1420": "Bank Ochrony Środowiska (BOŚ)",
};

export const extractBankName = (value: string): string | null => {
    const bankCode = value.substring(2, 6)
    return bankMapping[bankCode] || null;
}

export const extractBirthDateFromPesel = (pesel: string): string | null => {
    if (!/^\d{11}$/.test(pesel)) return null;

    const year = parseInt(pesel.substring(0, 2), 10);
    const month = parseInt(pesel.substring(2, 4), 10);
    const day = parseInt(pesel.substring(4, 6), 10);

    let fullYear = 1900 + year; // Default century
    if (month >= 1 && month <= 12) {
        fullYear = 1900 + year;
    } else if (month >= 21 && month <= 32) {
        fullYear = 2000 + year;
    } else if (month >= 41 && month <= 52) {
        fullYear = 2100 + year;
    } else if (month >= 61 && month <= 72) {
        fullYear = 2200 + year;
    } else if (month >= 81 && month <= 92) {
        fullYear = 1800 + year;
    } else {
        return null; // Invalid month
    }

    const adjustedMonth = (month % 20).toString().padStart(2, '0');
    return `${fullYear}-${adjustedMonth}-${day.toString().padStart(2, '0')}`;
};

export const extractSexFromPesel = (pesel: string): string | null => {
    if (!/^\d{11}$/.test(pesel)) return null;

    const genderDigit = parseInt(pesel[9], 10);
    return genderDigit % 2 === 0 ? 'k' : 'm';
};

export const extractMunicipalityCode = (district: string, municipality: string): string | null => {

    const lowerCaseDistrict = district.toLowerCase();
    const lowerCaseMunicipality = municipality.toLowerCase();
    const powiatData = powiatyGminyTyped[lowerCaseDistrict];
    if (!powiatData) {
        console.error(`Powiat "${lowerCaseDistrict}" not found.`);
        return null;
    }
    const gminaCode = powiatData[municipality.toLowerCase()];
    if (!gminaCode) {
        console.error(`Gmina "${lowerCaseMunicipality}" not found in powiat "${lowerCaseDistrict}".`);
        return null;
    }

    return gminaCode;
};

//Will be used for delaying field check in employees table if we find it suitable
export const useDebounce = (value: any, delay: number) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
};

export const isFloat = (value: string) => {
    const regex = /^[+-]?(?:\d+\.\d+|\d+)$/;
    const dotsReplaced = value.replace(",", ".");
    return regex.test(dotsReplaced) && !isNaN(parseFloat(dotsReplaced));
}

export const isInteger = (value: string) => {
    const regex = /^[+-]?\d+$/;
    return regex.test(value) && !isNaN(parseInt(value, 10));
}

export const redirectTo = (url: string) => {
    window.location.href = (window.location.protocol + "//" + window.location.host + url)
}